import { selectActivePlanningDomainUuid } from '~/store/slices/userSlice'
import { useStore } from '~/store/store'

/** The request's X-Planning-Domain header: the user's active planning domain, which the API scopes the request to. */
export function getPlanningDomainHeaders(): Record<string, string> {
    const uuid = selectActivePlanningDomainUuid(useStore.getState())
    return uuid === null ? {} : { 'X-Planning-Domain': uuid }
}
